export default __webpack_public_path__ + "static/media/santa-rosa.5f7245a7.jpg";